import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { MarketFeedState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketFeed/MarketFeed.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export interface MarketFeedPropsType {
    marketId: MarketId,
}

export const MarketFeed = observer('MarketFeed', (propsIn: MarketFeedPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new MarketFeedState(appState, props));
    const marketModel = props.marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    return (<>
        <h4>Feed</h4>
        <div className='row'>
            <div className='col-3'>
                <div className='element checkbox' data-test='feedSettings.updates'>
                    <label>
                        <input type='checkbox' defaultChecked={marketModel.feedSettings?.updates ?? false} onChange={state.onChangeUpdates} disabled={marketModel.feedSettings?.updates === undefined}/>
                        <span>
                            Updates
                        </span>
                    </label>
                </div>
            </div>

            <div className='col-3'>
                <div className='element checkbox' data-test='feedSettings.results'>
                    <label>
                        <input type='checkbox' defaultChecked={marketModel.feedSettings?.results ?? false} onChange={state.onChangeResults} disabled={marketModel.feedSettings?.results === undefined}/>
                        <span>
                            Results
                        </span>
                    </label>
                </div>
            </div>
            <div className='col-3'>
                <div className='element checkbox' data-test='feedSettings.prices'>
                    <label>
                        <input type='checkbox' defaultChecked={marketModel.feedSettings?.prices ?? false} onChange={state.onChangePrices} disabled={marketModel.feedSettings?.prices === undefined}/>
                        <span>
                            Prices
                        </span>
                    </label>
                </div>
            </div>
            <div className='col-3'>
                <div className='element checkbox' data-test='feedSettings.eachWay'>
                    <label>
                        <input type='checkbox' defaultChecked={marketModel.feedSettings?.eachWay ?? false} onChange={state.onChangeEachWay} disabled={marketModel.feedSettings?.eachWay === undefined}/>
                        <span>
                            Each Way
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </>);
});
